export const GAME_COMPLETED_EVENT = 'GAME_COMPLETED' as const;
/** Sent when the player leaves early (e.g. the debug exit button), as opposed
 * to GAME_COMPLETED_EVENT which means the game actually finished. */
export const GAME_EXITED_EVENT = 'GAME_EXITED' as const;
